import { ConditionalWrapper, ExternalLink, Text, Tooltip } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC } from "react";

import { useI18N } from "@sundae/react-hooks";
import { TeamMember } from "../../../gql/generated/taste-test.sdk";
import { IUseTasteTestPersonalization } from "../../../hooks/taste-test/useTasteTestPersonalization";
const {
  theme: { colors },
} = require("@sundae/tailwind-config");

const defaultPrimaryColor = colors.primary["DEFAULT"];

interface ITasteTestTeamMemberProps {
  tasteTestPersonalization?: IUseTasteTestPersonalization;
  teamMembers: TeamMember[] | undefined;
}

const TasteTestTeamMember: FC<ITasteTestTeamMemberProps> = ({
  tasteTestPersonalization,
  teamMembers,
}) => {
  const { t } = useI18N("taste-test");

  if (!teamMembers) return null;

  return (
    <div>
      {teamMembers.map(({ name, role, social }, index) => {
        return (
          <Tooltip
            key={`${name}-${index}`}
            trigger={
              <div className="inline cursor-help">
                <ConditionalWrapper
                  condition={Boolean(social)}
                  wrapper={(children) => (
                    <ExternalLink
                      arrow="top-right"
                      href={social?.url}
                      size="sm"
                      variant="info"
                      style={{
                        color: tasteTestPersonalization?.primaryColor ?? defaultPrimaryColor,
                      }}
                    >
                      {children}
                    </ExternalLink>
                  )}
                >
                  <Text
                    className={cx({
                      "ml-1": index !== 0,
                    })}
                    tag="span"
                    size="sm"
                    variant="current"
                  >
                    {name}
                  </Text>
                </ConditionalWrapper>

                {index !== (teamMembers.length ?? 0) - 1 && (
                  <Text tag="span" size="sm">
                    ,
                  </Text>
                )}
              </div>
            }
            tooltipLabel={`${role ?? ""}${social && role ? " - " : ""}${
              social ? t("detail.socials", { context: "profile", platform: social.name }) : ""
            }`}
          />
        );
      })}
    </div>
  );
};

export default TasteTestTeamMember;
